import { CSRF } from '../utils/CSRF'
import { BaseRepository } from './BaseRepository'

export type RecordingUploadObject = {
  file: Blob
  text: string
  session_id: string
}

export class PlaygroundRepository extends BaseRepository {
  getAllSessions() {
    return super.getHttpClientInstance().get('/api/playground/sessions', {
      'Content-Type': 'application/json',
      'X-CSRF-Token': CSRF.getToken(),
    })
  }

  createNewSession(sessionName: string) {
    return super.getHttpClientInstance().post(
      '/api/playground/new/tts',
      { name: sessionName },
      {
        'Content-Type': 'application/json',
        'X-CSRF-Token': CSRF.getToken(),
      },
    )
  }

  archiveSession(sessionUuid: string) {
    return super.getHttpClientInstance().post(
      '/api/playground/archive_session',
      { session_id: sessionUuid },
      {
        'Content-Type': 'application/json',
        'X-CSRF-Token': CSRF.getToken(),
      },
    )
  }

  archiveConversion(sessionUuid: string, conversionId: number) {
    return super.getHttpClientInstance().post(
      '/api/playground/archive_conversion',
      { conversion_id: conversionId, session_id: sessionUuid },
      {
        'Content-Type': 'application/json',
        'X-CSRF-Token': CSRF.getToken(),
      },
    )
  }

  synthesize(sessionId: string, content: string, prompt: string, enhancePrompt: boolean, speaker: string) {
    return super.getHttpClientInstance().post(
      'api/playground/synthesize/',
      {
        session_id: sessionId,
        body: content,
        prompt,
        enhance_prompt: enhancePrompt,
        speaker,
      },
      {
        'Content-Type': 'application/json',
        'X-CSRF-Token': CSRF.getToken(),
      },
    )
  }
}
